import { handleActions } from 'redux-actions'
import * as type from './type'

export const initialState = {
    monthList: [],
    fetching: false,
    error: null,
}

export default handleActions({

    [type.FETCH_BASIS_REPORT_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [type.FETCH_BASIS_REPORT_SUCCESS]: (state, action) => {
        const { monthList } = action.payload
        return {
            ...state,
            monthList,
            fetching: false,
        }
    },
    [type.FETCH_BASIS_REPORT_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/analytics/state/basis/reducer.js